import Image from 'next/image';
import IconWhite from './play_white.svg?url';
import type { SvgImageProps } from '../types';

export const PlayWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={IconWhite} alt={alt} {...props} />
);
